import React from "react";
import { AiOutlineForm } from 'react-icons/ai';

const AcuVolu = () => {

    return (
        <div className='pt-10'>
            <div className=" p-6 max-w-2xl mx-auto bg-white rounded-xl shadow-md flex items-center flex-col">            
                <h1 className=' font-bold text-principal text-2xl pb-4 font-sans'>Acuerdos de Voluntades</h1>

                <p className='text-xl font-sans text-center'>
                    Los Acuerdos de voluntades se refieren a acuerdos o convenios entre partes que han sido formalizados y certificados ante un notario público. Un notario público es un profesional del derecho con la autoridad para certificar documentos legales y actos jurídicos. La función principal del notario es dar fe pública y autenticar la legalidad de los documentos.
                </p>

                <a
                    href={`https://wa.me/+573104032213?text=Hola,%20quiero%20solicitar%20información%20sobre%20Acuerdos%20de%20Voluntades.`} target="_blank" rel="noopener noreferrer"
                    className='text-center bg-principal text-white py-2 px-6 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                    <AiOutlineForm size={25} className='inline-block mr-2' />
                    Solicitar
                </a>

            </div>
        </div>
    );
}

export default AcuVolu;